import { lazy } from "react";
import {
  isChunkLoadError,
  reloadOnceForStaleChunk,
  clearStaleChunkFlag,
} from "utils/chunkReload";

// Wraps React.lazy so a ChunkLoadError after a deploy triggers exactly one
// hard reload — picking up the fresh index.html with the new chunk hashes —
// instead of falling through to FallbackUI.

const lazyWithRetry = (factory) =>
  lazy(() =>
    factory().then(
      (mod) => {
        clearStaleChunkFlag();
        return mod;
      },
      (err) => {
        if (isChunkLoadError(err) && reloadOnceForStaleChunk()) {
          // Never-resolving promise so Suspense keeps the fallback up while
          // the page reloads, instead of bubbling to ErrorBoundary.
          return new Promise(() => {});
        }
        throw err;
      }
    )
  );

export default lazyWithRetry;
